/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { DictionaryItem, EnumDictionary } from '@gh/common-shared';
import { BitSet, createEnum, EnumSet } from '@gh/core-data';
import { includes } from 'lodash';
import { SystemRoleBit, systemRolesBitSet } from '../profiles';

export const UserSystemRole = createEnum('USER_SYSTEM_ROLE', {
  Corporate: 'CORPORATE',
  Master: 'MASTER',
  Franchisee: 'FRANCHISEE',
  Estimator: 'ESTIMATOR',
  Supervisor: 'SUPERVISOR',
  JobAdmin: 'JOB_ADMIN',
  Accountant: 'ACCOUNTANT',
  Salesperson: 'SALESPERSON',
});
export type UserSystemRole = EnumSet<typeof UserSystemRole>;

export function userSystemRoleToBitSet(userSystemRole: UserSystemRole): BitSet<SystemRoleBit> {
  return {
    [UserSystemRole.Corporate]: systemRolesBitSet(SystemRoleBit.Corporate),
    [UserSystemRole.Master]: systemRolesBitSet(SystemRoleBit.Master),
    [UserSystemRole.Franchisee]: systemRolesBitSet(SystemRoleBit.Franchisee),
    [UserSystemRole.Estimator]: systemRolesBitSet(SystemRoleBit.Estimator),
    [UserSystemRole.Supervisor]: systemRolesBitSet(SystemRoleBit.Supervisor),
    [UserSystemRole.JobAdmin]: systemRolesBitSet(SystemRoleBit.JobAdmin),
    [UserSystemRole.Accountant]: systemRolesBitSet(SystemRoleBit.Accountant),
    [UserSystemRole.Salesperson]: systemRolesBitSet(SystemRoleBit.SalesPerson),
  }[userSystemRole];
}

export function userSystemRoleFromBitSet(bitSet: BitSet<SystemRoleBit>): UserSystemRole {
  return {
    [systemRolesBitSet(SystemRoleBit.Corporate).toString()]: UserSystemRole.Corporate,
    [systemRolesBitSet(SystemRoleBit.Master).toString()]: UserSystemRole.Master,
    [systemRolesBitSet(SystemRoleBit.Franchisee).toString()]: UserSystemRole.Franchisee,
    [systemRolesBitSet(SystemRoleBit.Estimator).toString()]: UserSystemRole.Estimator,
    [systemRolesBitSet(SystemRoleBit.Supervisor).toString()]: UserSystemRole.Supervisor,
    [systemRolesBitSet(SystemRoleBit.JobAdmin).toString()]: UserSystemRole.JobAdmin,
    [systemRolesBitSet(SystemRoleBit.Accountant).toString()]: UserSystemRole.Accountant,
    [systemRolesBitSet(SystemRoleBit.SalesPerson).toString()]: UserSystemRole.Salesperson,
  }[bitSet.toString()];
}

export const filterSystemRolesEnumDictionary = (systemRoleList: UserSystemRole[]) =>
  (dictionary: EnumDictionary<UserSystemRole>) =>
    dictionary.filter(({ id: role }: DictionaryItem<any>) => includes(systemRoleList, role));
